module.exports = __webpack_public_path__ + "img/panturrilha-d.8b0248bd.png";